import { useNavigate } from 'react-router-dom';
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
  Button,
  Flex,
  List,
  ListItem,
  ListIcon,
} from '@chakra-ui/react';
import { WarningIcon, SettingsIcon } from '@chakra-ui/icons';

interface ActurisConfigBlockerProps {
  missingFields: string[];
  message: string | null;
  isAdmin?: boolean;
  userId?: number;
}

const ActurisConfigBlocker = ({
  missingFields,
  message,
  isAdmin,
  userId,
}: ActurisConfigBlockerProps) => {
  const navigate = useNavigate();

  const showUserButton = isAdmin && userId;

  return (
    <Alert
      status="warning"
      variant="subtle"
      flexDirection="column"
      alignItems="flex-start"
      borderRadius="md"
      p={4}
    >
      <Box display="flex" alignItems="center" mb={2}>
        <AlertIcon />
        <AlertTitle>Acturis Configuration Incomplete</AlertTitle>
      </Box>
      <AlertDescription>
        {message}
        {missingFields.length > 0 && (
          <List spacing={1} mt={2}>
            {missingFields.map((field, index) => (
              <ListItem key={index} fontSize="sm">
                <ListIcon as={WarningIcon} color="orange.500" />
                {field}
              </ListItem>
            ))}
          </List>
        )}
        {showUserButton && (
          <Flex mt={4} gap={2} flexWrap="wrap">
            <Button
              size="sm"
              colorScheme="orange"
              leftIcon={<SettingsIcon />}
              onClick={() => navigate(`/admin/settings/users/edit/${userId}`)}
            >
              Configure User
            </Button>
          </Flex>
        )}
      </AlertDescription>
    </Alert>
  );
};

export default ActurisConfigBlocker;
